import PeoperList from './PeoperList.vue'
export default PeoperList



// WEBPACK FOOTER //
// ./src/components/peoper-list/index.js